import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { GeneralMethods } from "../../Handlers/GeneralMethods";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { Router } from "../../Handlers/Router";
import HRPage from "../../../Component/Admin/HRPage";

export class AddNewMarketerVM extends InterActive{
    private marketerData:{name:string , email:string , dial_code:string , mobile:string , bank_account:string ,  commission:string } = {name:'' , email:'',dial_code:'' , mobile:'' , bank_account:'', commission:''}

    public get Data():{name:string , email:string , dial_code:string , mobile:string , bank_account:string ,  commission:string } { return this.marketerData}

    public set Name(value:string){ this.marketerData.name = value; this.update() }
    public set Email(value:string){ this.marketerData.email = value; this.update() }
    public set DialCode(value:string){ this.marketerData.dial_code = value; this.update() }
    public set Mobile(value:string) { this.marketerData.mobile = value; this.update() }
    public set BankAccount(value:string){ this.marketerData.bank_account = GeneralMethods.removeNonAlphanumeric(value); this.update() }
    public set Commission(value:string){ this.marketerData.commission = GeneralMethods.removeNonFloatNumeric(value); this.update() }

    public send(){
        if(this.validation()){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.AddNewMarketer(this.marketerData)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    Notify({type:'success' , title:'تمت العملية بنجاح' , body:'تمت عملية الاضافة بنجاح'})
                                    Router.OpenMasterPage({page:'موارد بشرية' , content:HRPage})
                                    this.update()
                                }else Notify({type:'danger' , title:'1فشل العملية' , body:response.data.messege})
                            }else {
                                Notify({type:'danger' , title:'2فشل العملية' , body:'فشل عملية الاضافة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                            }
                        }
                    }catch{ Notify({type:'danger' , title:'3فشل العملية' , body:'فشل عملية الاضافة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
                }
            )
        }
    }

    private validation(){
        if(!this.marketerData.name){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال اسم المسوق'});  return false; }
        if(this.marketerData.email){
            if(!GeneralMethods.isValidEmail(this.marketerData.email)){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال قيمة صالحة للايميل'});  return false; }
        }
        if(!this.marketerData.commission){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال نسبة العمولة للمسوق'});  return false; }
        else if(!GeneralMethods.isValidFloatNumber(this.marketerData.commission)){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال قيمة صالحة لعمولة المسوق'});  return false; }
        return true;
    }
}